import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { CreateWarehouseSchema } from '@app/models/wms';
import Api from '@app/services/api';

export const useCreateWarehouseQuery = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async (data: CreateWarehouseSchema) => {
      return await Api.wms.postWarehouse(data);
    },
    onSettled: () => client.invalidateQueries(['getWarehouses']),
    onSuccess: () => {
      message.open({
        type: 'success',
        content: commonT.t('dataAddSuccess'),
      });
    },
  });
};
